import React, { useEffect, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import Qs from 'qs'

import { HERO, HeroContext } from '../../../contexts/HeroContext'
import DestinationsDateFields from '../../fields/DestinationsDateFields'
import { calcNightsMoment } from '../../../helpers/searchHelpers'
import SubmitButton from '../../ui/SubmitButton'

const PackageSearchForm = ({
  minNights
}) => {

  const { state: {
    dropdown,
    activeDestinationTitle,
    activeDestinationHeading,
    activeDestination,
    destinations,
    arrival,
    nights
  }, dispatch } = useContext(HeroContext)

  const _setPlaying = (playing) =>
    dispatch({ type: HERO.PLAYING.SET, payload: playing })
  const _setDropdown = (dropdown) =>
    dispatch({ type: HERO.DROPDOWN.SET, payload: dropdown })
  const _setNights = (nights) =>
    dispatch({ type: HERO.NIGHTS.SET, payload: nights })
  const _setArrival = (arrival) =>
    dispatch({ type: HERO.ARRIVAL.SET, payload: arrival })
  const [displayLocationAside, setDisplayLocationAside] = useState(false)
  const [departure, setDeparture] = useState(null)
  const [valid, setValid] = useState(false)

  useEffect(() => {
    setValid(arrival & departure)
  }, [arrival, departure])

  useEffect(() => {
    // if departure set && < minNights, unset
    if(arrival && departure && nights) {
      let currentNights = calcNightsMoment(arrival, departure)
      if(currentNights < nights) setDeparture(null)
    }
  }, [nights])

  const getQueryString = () => {
    const queryObj = {
      destination: activeDestination
    }
    if(arrival) {
      queryObj.arrival = arrival != null ? arrival.format('YYYY-MM-DD') : arrival

      if(nights) {
        queryObj.nights = nights
      }
    }

    return `/packages?${Qs.stringify(queryObj)}`
  }

  const trackSeePackageDetailsClick = (e) => {
    if(!valid) {
      e.preventDefault()
    }
  }

  const toggleDropdown = (menu) => {
    if (!dropdown[menu].open) _setPlaying(false)

    let dropdownTmp = dropdown
    dropdownTmp[menu].open = !dropdownTmp[menu].open
    _setDropdown(dropdownTmp)
    setDisplayLocationAside(false)
  }

  const closeLocationAside = () => setDisplayLocationAside(false)

  return (
    <div className="drop-down-container">
      <div className="destination-wrapper">
        <label className="destination">Destination</label>
        {
          <div className="action-heading first-el">
            <span>I want to</span> <b>{activeDestinationHeading || "take a trip to"}</b>
          </div>
        }
      </div>
      <div
        className={`drop-down-button-container location ${
          destinations.length > 1 ? 'active' : ''
        }`}
      >
        <div className="inline-flex">
          <div
            className="content"
            onClick={() => toggleDropdown('destination')}
            >
              <div className="destination-name">
                <i className="fas fa-map-marker-alt" aria-hidden="true" />
                <button
                  id="js-destination"
                  className="drop-down selection"
                  aria-expanded="false"
                  aria-haspopup="true"
                  aria-label="open menu"
                  role="button"
                >
                  {activeDestinationTitle}
                </button>
              </div>
            <div className="dropdown-arrows">
              <i
                className="fas fa-caret-up"
                aria-hidden="true"
              />
              <i
                className="fas fa-caret-down"
                aria-hidden="true"
              />
            </div>
          </div>
          {
            displayLocationAside &&
            <aside>
              <i className="close" onClick={closeLocationAside}>X</i>
              <h3>Where would you like to visit?</h3>
              <p>Select from our list of extrodinary destinations!</p>
            </aside>
          }
        </div>
      </div>
      <div
        className={`drop-down-button-container date-field`}
        >
        <div className="date-labels">
          <label>Arrival</label>
          <label>Departure</label>
        </div>
        <DestinationsDateFields
          arrival      = {arrival}
          setArrival   = {_setArrival}
          minNights    = {minNights}
          setNights    = {_setNights}
          setPlaying   = {_setPlaying}
          departure    = {departure}
          setDeparture = {setDeparture}
          />
      </div>
      <p className="note">We take the hassle out of vacationing.<br/>Enjoy the savings and convenience of a Package Deal.</p>
      <div className="packages-link">
        <a
          href={getQueryString()}
          onClick={(e) => trackSeePackageDetailsClick(e)}
          >
          <SubmitButton
            handler     = {() => {}}
            disabled    = {!valid}
            label       = "Search Packages"
            aria-label  = "Search Packages"
            iconClasses = "fas fa-umbrella-beach"
          />
        </a>
      </div>
    </div>
  )
}

PackageSearchForm.propTypes = {
  minNights: PropTypes.number.isRequired
}

export default PackageSearchForm
